var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEdit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 10a.666.666 0 0 0-.667.666V16a.667.667 0 0 1-.667.667H4A.667.667 0 0 1 3.333 16V6.666C3.333 6.3 3.632 6 4 6h5.333a.666.666 0 1 0 0-1.334H4c-1.103 0-2 .898-2 2V16c0 1.103.897 2 2 2h9.333c1.103 0 2-.897 2-2v-5.334a.666.666 0 0 0-.666-.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.392a.338.338 0 0 0-.09.17l-.472 2.358a.334.334 0 0 0 .393.392l2.356-.472a.332.332 0 0 0 .171-.09l5.275-5.276-2.357-2.356-5.275 5.274zM17.512 2.488a1.668 1.668 0 0 0-2.357 0l-.922.922 2.356 2.357.923-.923c.315-.314.488-.732.488-1.178 0-.445-.173-.864-.488-1.178z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-edit.8210aba52053c3ae5389fdc7f8c90fe3.svg";